<template>
  <el-dialog width="40%" :visible="show" @close="closeDialog">
    <!-- 錯誤訊息popup -->
    <el-dialog
      width="30%"
      :title="alertMessage"
      :visible.sync="messageVisible"
      append-to-body>
      <div style="text-align:center">
        <el-button round type="danger" icon="now-ui-icons" @click="messageVisible=false">
          確認
        </el-button>
      </div>
    </el-dialog>
    <!--取消儲值popup -->
    <el-dialog
      width="30%"
      :title="cancelDepositMessage"
      :visible.sync="cancelDepositVisible"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="text-align:center">
        <el-button round type="" icon="now-ui-icons" :disabled="cancelling" @click="cancelDepositVisible=false">
          取消
        </el-button>
        <el-button round type="danger" icon="now-ui-icons" :disabled="cancelling" :loading="cancelling" @click="onCancelConfirmed">
          確認
        </el-button>
      </div>
    </el-dialog>
    <template slot="title">
      <h5>儲值明細</h5>
    </template>

    <div>
    <el-table :data="orderDataItems" :show-header="false">
      <el-table-column prop="billingAccountId" label="billingAccountId">
         <template slot-scope="{row}">
          <el-row> 
            <el-col :span="8">{{row.label}}</el-col>
            <el-col v-if="row.html" :span="16" style="text-align:right" v-html="row.value"></el-col>
            <el-col v-else :span="16" style="text-align:right" v-html="row.value">{{row.value}}</el-col>
          </el-row>
         </template> 
         
      </el-table-column>
    </el-table>
    <br/>
    <div style="text-align:center">
      <el-button round type="" icon="now-ui-icons" :disabled="!canCancel" :loading="cancelling" @click="onCancelDesposit">
        取消儲值
      </el-button>
      <el-button round type="danger" icon="now-ui-icons" @click="closeDialog">
        確認
      </el-button>
    </div>

    </div>
  </el-dialog>
</template>

<script>

import axios from 'axios';
import moment from 'moment';

export default {
  name: 'DepositRecordDetail',
  props: {
    show: Boolean,
    baId: Number,
    orderId: String
  },

  mounted() {
    if (this.orderId)
      this.fetchRecordData();
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    fetchOrderData() {
      this.loading = true;
      // let apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}/records/${this.orderId}`;
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/deposit-records/${this.orderId}`;

      axios.get(
        `${apiHost}`
      )
      .then(response => {
        this.order = response.data;
      })
      .catch(err => {
        console.error(`[DialogDepositRecordDetail] fetchOrderData: fallback request failed as well`, err);
        let message;
        if (err.data && err.data.message)
          message = err.data.message;
        this.$notify.error({
          title: '無法取得此訂單之明細！',
          message: message || ''
        });
      })
      .finally(() => {
        this.loading = false;
      });
    },

    checkExpiration(expiredAt){
      if (!expiredAt) return true;
      let current = moment();
      let expired = moment.unix(expiredAt);
      console.log(current.format('YYYY/MM/DD HH:mm:ss'), expired.format('YYYY/MM/DD HH:mm:ss'), current.diff(expired) > 0)
      return current.diff(expired) > 0 ? true : false
    },

    onCancelDesposit () {
      console.log('try to cancel deposit record.');
      if (this.order.depositStatus !== 'paid') {
        this.alertMessage = '目前無法無法取消此筆儲值，請確認儲值狀態。';
        this.messageVisible = true;
        // 要記得return，因為是用el-dialog顯示錯誤訊息
        return; 
      }
      // 檢查儲值時間
      let maxDiff = 1; // day
      //（儲值金成立入帳）的24小時內才可以取消
      let current = moment();
      let paidAt = moment.unix(this.order.paidAt);
      let diff = current.diff(paidAt, 'day');
      // let today = moment().startOf('day');
      // let paidAt = moment.unix(this.order.paidAt).startOf('day');
      // let diff = today.diff(paidAt, 'day');
      if (diff >= maxDiff) {
        this.alertMessage = '已超過取消時間，請聯絡客服處理。';
        this.messageVisible = true;
        return;
      }
      // console.log('paidAt:', paidAt);
      // console.log('today:', today)
      // console.log('diff:', today.diff(paidAt, 'day'));
      this.cancelDepositMessage = '是否確定取消此筆儲值？';
      this.cancelDepositVisible = true;
    },
    onCancelConfirmed(){
      this.cancelling = true;
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/deposit-records/${this.orderId}`;
      // let apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/billing-accounts/${this.baId}/records/${this.orderId}`;

      axios.request({
        method: "delete",
        url: `${apiHost}`,
      })
      .then(response => {
        this.fetchOrderData();
        this.$notify.success({
          title: '儲值已取消。'
        });
        this.$emit('cancelled');
      })
      .catch(err => {
        console.error(`[DialogDepositRecordDetail] cancel failed.`, err);
        let message;
        if (err.data && err.data.message)
          message = err.data.message;
        this.$notify.error({
          title: '無法取消此筆儲值！',
          message: message || ''
        });
      })
      .finally(() => {
        this.cancelDepositVisible = false;
        this.cancelling = false;
      });
    }
  },

  data() {
    return {
      loading: false,
      order: { },
      alertMessage: '',
      messageVisible: false,
      cancelDepositMessage: '',
      cancelDepositVisible: false,
      cancelling: false,
    };
  },

  computed: {
    canCancel () {
      // 先判斷BA狀態
      if (this.order.billingAccountStatus === 'active') {
        //判斷PAN狀態，TBD：判斷PAN ID
        if (this.order.linkedPanStatus === 'activated') {
          return this.order.depositStatus === 'paid' && !this.cancelling;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    orderDataItems () {
      if (!this.order) return [];
      let depositStatus = null;
      switch(this.order.depositStatus) {
        case 'paid':
          depositStatus = '<i class="el-icon-check" style="font-size: 16px; color:green"></i> 儲值成功';
          break;
        case 'cancelled':
          depositStatus = '<i class="el-icon-minus" style="font-size: 16px; color:red"></i> 已取消';
          break;
        case 'refunded':
          depositStatus = '<i class="el-icon-minus" style="font-size: 16px; color:red"></i> 已退回';
          break;
        case 'fail':
          depositStatus = '<i class="el-icon-close" style="font-size: 16px; color:red"></i> 儲值失敗';
          break;
        default:
          if (this.checkExpiration(this.order.expiredAt)) {
            depositStatus = '<i class="el-icon-close" style="font-size: 16px; color:red"></i> 已超過付款期限';
          } else {
            depositStatus = this.order.paymentOption === 'vac' ? '<i class="el-icon-time" style="font-size: 16px; color:orange"></i> 等待匯款': '<i class="el-icon-time" style="font-size: 16px; color:orange"></i> 等待付款';
          }
          break;
                    
      }
      let displayItems = {
        depositRecordId: {
          label: '儲值記錄ID',
          show: true,
          value : this.order.depositRecordId
        },
        depositOrderId: {
          label: '交易編號',
          show: true,
          value : this.order.depositOrderId
        },
        billingAccountId: {
          label: '帳戶ID',
          show: true,
          value : this.order.billingAccountId
        },
        billingAccountName: {
          label: '帳戶名稱',
          show: true,
          value : this.order.billingAccountName
        },
        memberId: {
          label: '操作者ID',
          show: false,
          value : this.order.memberId
        },
        memberName: {
          label: '操作者',
          show: true,
          value : this.order.memberName
        },
        createdAt: {
          label: '訂單時間',
          show: true,
          value : moment.unix(this.order.createdAt).format('YYYY/M/D h:mmA')
        },
        amount: {
          label: '本次儲值點數',
          show: true,
          value: this.order.amount ?  Number(this.order.amount).toLocaleString(): ''
        },
        expiredAt: {
          label: '付款期限',
          show: false,
          value : this.order.expiredAt ? moment.unix(this.order.expiredAt).format('YYYY/M/D h:mmA'): ''
        },
        paidAt: {
          label: '儲值時間',
          show: true,
          value : this.order.paidAt ? moment.unix(this.order.paidAt).format('YYYY/M/D h:mmA'): ''
        },
        paymentOption: {
          label: '付款方式',
          show: true,
          value: this.order.paymentOption === 'ddpay' ? '信用卡': this.order.paymentOption === 'vac' ? '銀行匯款' : ''
          // value: (this.order.depositStatus === 'paid') ? this.order.ddpayOrderId ? '線上付款': '銀行匯款' : ''
        },
        depositStatus: {
          label: '儲值狀態',
          show: true,
          html: true,
          value: depositStatus
        },
        ddpayOrderId: {
          label: '支付交易編號',
          show: true,
          value: this.order.ddpayOrderId
        },
        invoiceInfo: {
          label: '發票號碼',
          show: false,
          value: this.order.invoiceInfo ? this.order.invoiceInfo.number : ''
        },
        invoiceEmail: {
          label: '發票開立信箱',
          show: false,
          value: ''
        }
      };

      let items = []
      for (const [key, value] of Object.entries(displayItems)) {
        if (value.show)
          items.push(value);
      }
      return items;

    },
    userType() {
      return this.$store.getters.userType;
    }
  },

  filters: {
    toDateTimeString(ts) {
      return moment.unix(ts).format('YYYY/M/D h:mmA');
    },
  },

  watch: {
    orderId: function(id) {
      this.order = {};
      this.fetchOrderData();
    }
  }
}
</script>

<style scoped>

</style>